import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";

/**
 * Get parsed URL using Path Params
 * @description Replace the URL with the given replacers
 * @example getParsedURL('https://api.example.com/v1/users/[id]', [{ id: '123' }])
 */
const getParsedURL = (
  url: string,
  urlReplacers: Array<Record<string, unknown>>,
  forTests?: boolean,
) => {
  urlReplacers.forEach((replacer) => {
    Object.entries(replacer).forEach(([key, value]) => {
      if (value) {
        url = url.replace(`[${key}]`, String(value));
      } else {
        url = url.replace(`/[${key}]`, "");
      }
    });
  });

  if (forTests) {
    return `${MONOLITH_ORIGIN}${url}`;
  }

  return url;
};
export default getParsedURL;
